<script>
	import _ from 'lodash'
	import FilterTypesBy from './filter-types.js'

	export default {
		props: {
			options: { type: Object },
			modelValue: { type: Object }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				localValue: {
					key: null,
					filter: 'contains',
					value: null,
					type: 'string'
				},
				defaultInputOptions: {
					mode: 'string',
					emitInitValue: true
				}
			}
		},
		computed: {
			inputOptions() {
				let defs = {
					mode: this.localValue.type
				}

				return _.extend({}, this.defaultInputOptions, defs)
			},
			filterTypes() {
				return FilterTypesBy(this.localValue.type)
			}
		},
		watch: {
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					if (_.isEqual(this.localValue, val)) {
						return
					}

					this.localValue = _.extend(this.localValue, val)
					this.validateFilterType()
					this.defer(() => this.setInputAsChanged(), 100)
				}
			}
		},
		created() {
		},
		mounted() {

		},
		methods: {
			valueChanged() {
				this.$emit('update:modelValue', this.localValue)
			},
			validateFilterType() {
				if (this.filterTypes.filter(x => x.value === this.localValue.filter).length === 0) {
					let filter = _.head(this.filterTypes)
					this.localValue.filter = (filter || {}).value
					this.valueChanged()
				}
			},
			setInputAsChanged() {
				if (this.$refs.input) {
					this.$refs.input.onChanged()
				}
			}
		}
	}
</script>
<template>
	<div class="row no-gutters">
		<div class="col-12 col-md-auto ml-md-1">
			<select v-model="localValue.filter" class="form-control form-control-sm" @change="valueChanged">
				<option v-for="item of filterTypes" :value="item.value" :key="item.value">{{ item.text }}</option>
			</select>
		</div>
		<div class="col-12 col-md">
			<nk-input v-model="localValue.value" :options="inputOptions" @update:modelValue="valueChanged" ref="input" />
		</div>
	</div>
</template>
